import { useQueryClient } from "@tanstack/react-query";

import { useMutationRequest, useRequest } from "~/v2/api/hooks";
import {
  getRiskControls,
  riskControlsQueryKeys,
  type SetRiskControlParams,
  setRiskControl,
} from "~/v3-poc/api/riskControls";
import type { RiskControls } from "~/v3-poc/api/riskControls.schema";

export interface UseGetRiskControlsArgs {
  accountID?: string;
  enabled?: boolean;
}

export const useGetRiskControls = ({
  accountID,
  enabled = true,
}: UseGetRiskControlsArgs) =>
  useRequest(
    riskControlsQueryKeys.detail(accountID ?? ""),
    () => getRiskControls(accountID ?? ""),
    {
      enabled: enabled && !!accountID,
      meta: { showErrorToast: false },
    },
  );

export const useSetRiskControl = () => {
  const queryClient = useQueryClient();

  return useMutationRequest<RiskControls, SetRiskControlParams>(
    setRiskControl,
    {
      // The response is gobroker's read-back, so it is more authoritative than
      // a refetch would be — seed the cache rather than invalidate.
      onSuccess: (controls, { accountID }) => {
        queryClient.setQueryData(
          riskControlsQueryKeys.detail(accountID),
          controls,
        );
      },
    },
  );
};
